import { useEffect, useState } from "react";
import { api } from "../api/client.js";
import { getTg } from "../telegram/sdk.js";

export interface AuthState {
  status: "idle" | "loading" | "ok" | "error";
  error?: string;
  user?: {
    telegramId: number;
    username: string | null;
    firstName: string | null;
    balance: number;
  };
}

export function useAuth(): AuthState & { refresh: () => Promise<void> } {
  const [state, setState] = useState<AuthState>({ status: "idle" });

  const run = async () => {
    setState({ status: "loading" });
    try {
      const tg = getTg();
      const initData =
        tg?.initData ||
        // DEV fallback — only works if your backend has a dev-bypass.
        new URLSearchParams(location.search).get("initData") ||
        "";
      if (!initData) {
        setState({
          status: "error",
          error: "Открой мини-апп из Telegram (initData отсутствует).",
        });
        return;
      }
      const res = await api.auth(initData);
      setState({ status: "ok", user: res.user });
    } catch (e) {
      setState({ status: "error", error: (e as Error).message });
    }
  };

  useEffect(() => {
    void run();
  }, []);

  return { ...state, refresh: run };
}
